import { useNotificationSoundStore } from '../stores/notificationSoundStore'
import type { INotificationDto } from '../types/notification.types'
import { getNotificationVisual } from './useNotificationType'

/**
 * Композбл воспроизведения звука уведомлений.
 *
 * Audio-инстанс создаётся лениво (на первом play) и переиспользуется — это позволяет
 * быстро перезапускать звук при серии уведомлений подряд.
 */

const SOUND_PATH = '/sound/notificationAlert.mp3'

let audio: HTMLAudioElement | null = null

function getAudio(): HTMLAudioElement | null {
  if (typeof window === 'undefined') return null
  if (audio === null) {
    audio = new Audio(SOUND_PATH)
  }

  return audio
}

export function useNotificationSound() {
  const soundStore = useNotificationSoundStore()

  /**
   * Сыграть звук, если настройки звука разрешают для типа конкретного уведомления.
   * DTO передаётся явным аргументом — не полагаемся на состояние стора, чтобы при
   * дедупе/гонках не сыграть звук по чужому типу.
   */
  function play(dto: INotificationDto): void {
    const visual = getNotificationVisual(dto.message_type)
    if (!soundStore.shouldPlay(visual.color)) return

    const a = getAudio()
    if (a === null) return
    try {
      a.currentTime = 0
      const promise = a.play()
      if (promise && typeof promise.catch === 'function') {
        promise.catch(() => {
          /* автоплей заблокирован браузером до первого клика — тихо */
        })
      }
    } catch {
      /* defensive */
    }
  }

  return { play }
}
